export function getPairParticipant(booking, currentUserId) {
  return booking?.booking_participants.find(
    (bookingParticipant) => bookingParticipant.user_id !== currentUserId
  );
}
